import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class Logs extends ApiBase {
    constructor(store) {
        const path = ACTIVE_BASE_REST + '/log'
        super(store, path)
    }

    report(entity,filter, showProgress) {
        return this._request({
            action: entity + '/report',
            method: 'GET',
            params: filter,
            showProgress
        })
    }

    getLogDetail(entity,id, showProgress) {
        return this._request({
            action: entity + '/' + id,
            method: 'GET',
            showProgress
        })
    }
}